var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({class:_vm._class,on:{"click":_vm.onClick}},_vm.$listeners),[_c('span',{class:_vm._linkClass},[_vm._t("default")],2),_c('span',{class:_vm._separatorClass},[_c('render-cell',{attrs:{"render":_vm.renderSeparator}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }